"use client";

// cursorGlow — mancha violeta grande y tenue que sigue el cursor por toda
// la landing, con inercia (lerp .12 por frame, igual que `glowLoop()` del
// handoff). Se monta una sola vez a nivel de página.

import { useEffect, useRef } from "react";

export function CursorGlow() {
  const elRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const el = elRef.current;
    if (!el) return;

    let gx = -999, gy = -999, tx = -999, ty = -999;
    let raf: number | null = null;

    function onMove(e: MouseEvent) { tx = e.clientX; ty = e.clientY; }
    function loop() {
      gx += (tx - gx) * 0.12;
      gy += (ty - gy) * 0.12;
      if (el) { el.style.left = `${gx}px`; el.style.top = `${gy}px`; }
      raf = requestAnimationFrame(loop);
    }

    window.addEventListener("mousemove", onMove);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={elRef} id="tl-cursor-glow" />;
}
